
export const AutoPayColumns = (changeStatus) => {
    const checkStatus = (name,row) => {
        if(name == true) {
  
          return (<label className="switch"  style={{ padding: row.id && !!expanded[row.id] ? '0' : '3px' }} onClick={(event) => {
            event.preventDefault(); // Prevent the default action
            changeStatus(row); // Call your changeStatus function
          }}>
          <input type="checkbox" className="switch-input"  checked />
          <span className="switch-label" data-on="Enable" data-off="Deactive" />
          <span className="switch-handle" />
        </label>)
        } else {
          return (
  
            <div data-tag="allowRowEvents"><label className="switch" onClick={(event) => {
              event.preventDefault(); // Prevent the default action
              changeStatus(row); // Call your changeStatus function
            }}><input type="checkbox" className="switch-input" /><span className="switch-label" data-on="Active" data-off="Disable" /><span className="switch-handle" /></label></div>
          );
        }
    }
    return [
      {
        name: 'Agent Name',
        selector: row => row.agent_name,
        sortable: true,
      },
      {
        name: 'Agent Code',
        selector:  row =>
        row.agent_code,
  
        sortable: true,
      },
      {
        name: 'Distributor Name',
        selector: row => row.distributor_name,
        sortable: true,
      },
      {
        name: 'Distributor Code',
        selector: row => row.distributor_code,
        
        sortable: true,
      },
      {
        name: 'Auto Pay',
        selector: row => checkStatus(row.auto_pay, row),
        sortable: true,
      },
      
    ]
  }
  